import { render } from "./PageDashboard.vue?vue&type=template&id=5bc4bfb8&scoped=true"
import script from "./PageDashboard.vue?vue&type=script&lang=js"
export * from "./PageDashboard.vue?vue&type=script&lang=js"

import "./PageDashboard.vue?vue&type=style&index=0&id=5bc4bfb8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bc4bfb8"]])

export default __exports__